import {
  SearchApiModel,
  useAxios,
  useDeleteNulls,
  useHandleApiError,
} from '@sttedra_ui/framework';

import TownApiResponseModel from './town.api-response-model.js';

// #region Globals
const {base} = useAxios();
const CONTEXT_BASE_PATH = 'poblacion';
const DEFAULT_TIMEOUT = 5000;
const BIG_SIZE_SEARCH = 500;
const {handleApiError} = useHandleApiError();
// #endregion

function makeSttedraParamsFromName(name) {
  return {
    pageIndex: 1,
    pageSize: BIG_SIZE_SEARCH,
    sortField: 'population',
    sortOrder: 'DESC',
    globalSearch: {
      value: name,
      fields: [
        'name',
      ],
    },
  };
}
// #region Public functions
async function searchTownName(name, throwError = true) {
  const {data} = await searchTown(makeSttedraParamsFromName(name), throwError);
  return data;
}

async function searchTown(searchParams = {}, throwError = true) {
  try {
    const searchModel = new SearchApiModel(searchParams);

    useDeleteNulls(searchModel);

    const url = '/' + CONTEXT_BASE_PATH;

    const {data: response} = await base.post(url, searchModel, {
      timeout: DEFAULT_TIMEOUT,
    });

    const {data: originalData, pageSize, pageIndex, totalResults} = response;

    const data = originalData.map((u) => new TownApiResponseModel(u));

    return {data, pageSize, pageIndex, totalResults};
  } catch (err) {
    if (!throwError) {
      return handleApiError(err);
    }
    throw err;
  }
}

// #endregion

// #region Private functions
// ...
// #endregion

export {
  searchTown,
  searchTownName,
};
